// extracted by mini-css-extract-plugin
export default {"overlay":"zw-z","bodyOpen":"Aw-z","content":"Bw-z","header":"Cw-z","close":"Dw-z","closeNoHeading":"Ew-z"};